export default __webpack_public_path__ + "static/media/undraw_credit_card_re_blml.261df05b.svg";